module.exports = __webpack_public_path__ + "static/media/AMX-Bold.44ea25b3.ttf";